module.exports = __webpack_public_path__ + "img/avatar-placeholder.fa386872.png";